import { ChangeEvent, Dispatch, SetStateAction } from 'react';

import { IUploadFile } from '../interfaces/IUploadFile';
import { mapFileExtByMimeType } from '../constants/mapFileExtByMimeType';

export const uploadFile = async (
  e: ChangeEvent<HTMLInputElement>,
  files: IUploadFile[],
  setFiles: Dispatch<SetStateAction<IUploadFile[]>>,
  nameIfExists?: string,
) => {
  const fileList = e.target.files || [];
  const filesArray = Array.from(fileList);
  const file = filesArray[0];
  const data = new FormData();
  const fileName = nameIfExists || file.name;
  const fileType = file.type;
  const fileExt = fileName.split('.')[1];
  const fileSize = file.size ?? 0;
  const mimeType = mapFileExtByMimeType[fileExt] || undefined;
  const blob = new Blob([file], { type: mimeType });

  data.append('attachment', blob, fileName);
  const uploadingFiles = [
    ...files,
    {
      fileId: null,
      fileName,
      fileSize,
      fileType,
      data,
    },
  ];

  setFiles(uploadingFiles);
};
